// --- Import components
// import * as format from './components/input-formatter';
// import lightbox from './components/lightbox';
// import modal from './components/modal';
// import tabs from './components/tabs';
// import fileUploader from './components/file-uploader';
// import carousel from './components/carousel';
// import multiSelect from './components/multi-select';
// import datePicker from './components/datepicker';

// --- Import functions
import WebFont from 'webfontloader';
import Flickity from 'flickity';
import showHide from './functions/showhide';
import browserDeviceDetect from './functions/browser-device-detect';

WebFont.load({
  google: {
    families: ['Montserrat:300,400,500,700,800,900:latin-ext'],
  },
});

// --- Ready
document.addEventListener('DOMContentLoaded', () => {
  browserDeviceDetect();

  showHide();

  const reservationSlider = document.querySelector('.reservation-box-slider');
  if (reservationSlider) {
    const prevBtn = document.querySelector('.scroll-trigger--left');
    const nextBtn = document.querySelector('.scroll-trigger--right');
    const flkty = new Flickity(reservationSlider, {
      // options
      cellAlign: 'center',
      contain: true,
      // disable previous & next buttons and dots
      prevNextButtons: false,
      pageDots: false,
    });
    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => {
        flkty.previous();
      });
      nextBtn.addEventListener('click', () => {
        flkty.next();
      });
      flkty.on('cellSelect', () => {
        // enable/disable previous/next buttons
        if (!flkty.cells[flkty.selectedIndex - 1]) {
          // on first cell
          prevBtn.classList.add('disabled');
        } else if (!flkty.cells[flkty.selectedIndex + 1]) {
          // on last cell
          nextBtn.classList.add('disabled');
        } else {
          prevBtn.classList.remove('disabled');
          nextBtn.classList.remove('disabled');
        }
      });
    }
  }

  const companyDetailsCheckbox = document.getElementById('company-invoice');
  const companyDetailsFormGroup = document.querySelector('.company-details');

  if (companyDetailsCheckbox && companyDetailsFormGroup) {
    companyDetailsCheckbox.addEventListener('change', () => {
      if (companyDetailsCheckbox.checked == true) {
        companyDetailsFormGroup.classList.remove('is-hidden');
      } else {
        companyDetailsFormGroup.classList.add('is-hidden');
      }
    });
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js